"use strict";

define('rs/modals/person.finder/person.finder.controller',['require','exports','module','rs/modals/table.finder/table.finder.controller','e3-table','rs/models/person'],function (require, exports, module) {
  var RSFinderController = require('rs/modals/table.finder/table.finder.controller');
  var E3Table = require('e3-table');
  var RSPersonModel = require('rs/models/person');
  var PersonFinderController = RSFinderController.extend({
    defaultTitle: 'Person Finder',
    columns: [{
      name: 'displayName',
      displayName: 'Name',
      type: 'String',
      width: '25%'
    }, {
      name: 'organization',
      displayName: 'Organization',
      type: 'String',
      width: '23%'
    }, {
      name: 'email',
      displayName: 'Email',
      type: 'String',
      width: '25%'
    }, {
      name: 'phone',
      displayName: 'Phone',
      type: 'String',
      width: '20%'
    }, {
      className: 'btn-add-member',
      width: '7%',
      sortable: false,
      isIconButton: true,
      processItemText: function processItemText() {
        return new Handlebars.SafeString('<button role="button" tabindex="0" aria-label="add" class="fa-icon fa-icon-plus"></button>');
      }
    }],
    processFilter: function processFilter(items, filter) {
      if (filter.field) {
        return _.filter(items, function (item) {
          if (item.item[filter.field] == filter.value) {
            return true;
          }
        });
      }
      return items;
    },
    _requestTableItems: function _requestTableItems(searchQuery) {
      return RSPersonModel.getQuery(searchQuery);
    }
  }, {
    show: function show(properties, modalOptions) {
      return RSFinderController.show.apply(this, arguments).then(function (persons) {
        return Promise.map(persons, function (p) {
          return p.requestDetails();
        });
      });
    }
  });
  module.exports = PersonFinderController;
});

